/** @format */

import { BsChevronDoubleLeft, BsChevronDoubleRight } from "react-icons/bs";

const Paginations = ({
  pageNumber,
  setPageNumber,
  totalItem,
  parPage,
  showItem,
}) => {
  let totalPage = Math.ceil(totalItem / parPage);
  let startPage = pageNumber;
  let dif = totalPage - pageNumber;

  if (showItem > 4) {
    showItem = 4;
  }

  if (dif <= showItem) {
    startPage = totalPage - showItem;
  }

  let endPage = startPage < 0 ? showItem : showItem + startPage;
  //let endPage = Math.min(startPage + showItem, totalPage + 1);

  if (startPage <= 0) {
    startPage = 1;
  }

  const createBtn = () => {
    const btns = [];
    for (let i = startPage; i < endPage; i++) {
      btns.push(
        <li
          key={i} // Add key here
          onClick={() => setPageNumber(i)}
          className={`${
            pageNumber === i
              ? "bg-slate-300 shadow-lg shadow-slate-300/50 text-white"
              : "bg-slate-500 hover:bg-slate-300 shadow-lg hover:shadow-slate-300/50 hover:text-white text-slate-800"
          } w-[33px] h-[33px] rounded-full flex justify-center items-center cursor-pointer`}
        >
          {i}
        </li>,
      );
    }
    return btns;
  };

  return (
    <ul className='flex gap-3'>
      {pageNumber > 1 && (
        <li
          onClick={() => setPageNumber(pageNumber - 1)}
          className='w-[33px] h-[33px] rounded-full flex justify-center items-center bg-slate-700 text-[#d0d2d6] cursor-pointer'
        >
          <BsChevronDoubleLeft />
        </li>
      )}
      {createBtn()}
      {pageNumber < totalPage && (
        <li
          onClick={() => setPageNumber(pageNumber + 1)}
          className='w-[33px] h-[33px] rounded-full flex justify-center items-center bg-slate-700 text-[#d0d2d6] cursor-pointer'
        >
          <BsChevronDoubleRight />
        </li>
      )}
    </ul>
  );
};

export default Paginations;
